import { render, staticRenderFns } from "./ProductionInfo.vue?vue&type=template&id=71076cf8&scoped=true&"
import script from "./ProductionInfo.vue?vue&type=script&lang=js&"
export * from "./ProductionInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductionInfo.vue?vue&type=style&index=0&id=71076cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71076cf8",
  null
  
)

export default component.exports